// extracted by mini-css-extract-plugin
export var compactFilters = "_db-4";
export var detailImage = "_db-1";
export var dropdownContainer = "_db-2";
export var imageContainer = "_db-0";
export var selectedCard = "_db-3";